var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCorrectIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 0C3.63438 0 0.5 3.13438 0.5 7C0.5 10.8656 3.63438 14 7.5 14C11.3656 14 14.5 10.8656 14.5 7C14.5 3.13438 11.3656 0 7.5 0ZM10.5234 4.71406L7.23281 9.27656C7.18682 9.34076 7.12619 9.39306 7.05595 9.42914C6.98571 9.46523 6.90787 9.48405 6.82891 9.48405C6.74994 9.48405 6.67211 9.46523 6.60186 9.42914C6.53162 9.39306 6.47099 9.34076 6.425 9.27656L4.47656 6.57656C4.41719 6.49375 4.47656 6.37813 4.57812 6.37813H5.31094C5.47031 6.37813 5.62187 6.45469 5.71562 6.58594L6.82812 8.12969L9.28438 4.72344C9.37813 4.59375 9.52812 4.51562 9.68906 4.51562H10.4219C10.5234 4.51562 10.5828 4.63125 10.5234 4.71406Z",
    fill: "#52C41A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCorrectIcon);
export default __webpack_public_path__ + "static/media/correctIcon.7afa9fba2021c6ef2a633aeabc0073dd.svg";
export { ForwardRef as ReactComponent };